export default {
  'Text': '文字',
  'Styles': '样式',
  'Text here': '在这里输入文字',
  'Add subtitles': '添加字幕',
  'Text Color': '文字颜色',
  'Outline': '外框',
  'Background': '背景',
  'Position': '位置',
}